module.exports = __webpack_public_path__ + "static/img/xinfeng-wai-no-active.2103a865.png";